import { render } from "./HostCustomNotification.vue?vue&type=template&id=5e55249c"
import script from "./HostCustomNotification.vue?vue&type=script&lang=js"
export * from "./HostCustomNotification.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__